import {SVGAttributes} from 'react';

export default function StopwatchSVG(props: SVGAttributes<HTMLOrSVGElement>) {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 21 24"
      version="1.1"
      {...props}>
      <defs>
        <path
          d="M17.6516,6.408 C19.8162,8.36 21,11.02 21,13.844 C21,19.458 16.303,24 10.5,24 C4.69616,24 0,19.457 0,13.844 C0,8.506 4.22802,4.197 9.53077,3.731 L9.53077,1.875 L6.68768,1.875 C6.15238,1.875 5.71845,1.455 5.71845,0.938 C5.71845,0.42 6.15238,0 6.68768,0 L14.3123,0 C14.8476,0 15.2815,0.42 15.2815,0.938 C15.2815,1.455 14.8476,1.875 14.3123,1.875 L11.46923,1.875 L11.46923,3.731 C13.1316,3.877 14.7126,4.398 16.1059,5.252 L17.4392,3.962 C17.8177,3.596 18.4314,3.596 18.8099,3.962 C19.1885,4.328 19.1885,4.922 18.8099,5.288 L17.6516,6.408 Z M10.5,22.125 C15.2208,22.125 19.0615,18.41 19.0615,13.844 C19.0615,9.277 15.2209,5.562 10.5,5.562 C5.77913,5.562 1.93846,9.277 1.93846,13.844 C1.93846,18.41 5.77917,22.125 10.5,22.125 Z M11.46923,8.312 L11.46923,13.844 C11.46923,14.362 11.03531,14.781 10.5,14.781 C9.96469,14.781 9.53077,14.362 9.53077,13.844 L9.53077,8.312 C9.53077,7.795 9.96469,7.375 10.5,7.375 C11.03531,7.375 11.46923,7.795 11.46923,8.312 Z"
          id="path-1"></path>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="Group-70">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1"></use>
          </mask>
          <use id="Clip-69" fill="currentColor" xlinkHref="#path-1"></use>
        </g>
      </g>
    </svg>
  );
}
